import * as React from 'react';

import { theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

type Props = {
  stepNumber: number;
  totalSteps: number;
};

const Wrapper = styled.div`
  padding: 0.5rem;
  border-bottom: 1px solid ${theme.color.border.divider};
  text-align: center;
  color: ${theme.color.text.secondary};
  ${theme.typography.labelSmall}
`;

export const RoutineStepIndicator = ({ stepNumber, totalSteps }: Props) => {
  return (
    <Wrapper>
      {stepNumber}/{totalSteps}
    </Wrapper>
  );
};
